import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import { PANEL_HEIGHT } from "lib/styles/constants";

export const { styles, ids } = ResponsiveStyleSheet.create({
  panel: createResponsiveStyles({
    base: {
      overflow: "visible",
    },
    large: {
      justifyContent: "flex-start",
      height: PANEL_HEIGHT,
    },
  }),
  productDate: createResponsiveStyles({
    base: {
      color: theme.colors.brand.base,
      textAlign: "left",
      fontFamily: "ProximaBold",
    },
  }),

  dateError: {
    position: "absolute",
    top: 300,
    right: theme.spacing.xsmall,
  },
  timeslotError: {
    position: "absolute",
    bottom: -30,
    right: theme.spacing.xsmall,
  },
  deliveryOptionWrap: {
    flexDirection: "row",
    flex: 1,
    padding: 10,
  },
  deliveryOptionAccent: {
    backgroundColor: theme.colors.positive.darker,
    borderRadius: theme.spacing.xsmall,
  },
  deliveryOptionBorder: {
    borderBottomColor: theme.colors.greyscale.lightest,
    borderBottomWidth: 2,
  },

  deliveryOption: {
    paddingRight: theme.spacing.xsmall,
  },
});
